import { createFileRoute } from "@tanstack/react-router";
import { SettingsPage } from "../features/settings/SettingsPage";
import type { SettingsSection } from "../features/shell/ShellContext";

const SECTIONS: SettingsSection[] = [
  "profile",
  "preferences",
  "groups",
  "emoji",
  "hosting",
  "flare",
  "agents",
  "guardrails",
  "billing",
];

export const Route = createFileRoute("/w/$ws/settings")({
  validateSearch: (search: Record<string, unknown>): { section?: SettingsSection } =>
    SECTIONS.includes(search.section as SettingsSection)
      ? { section: search.section as SettingsSection }
      : {},
  component: () => <SettingsPage section={Route.useSearch().section ?? "profile"} />,
});
